import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import { Icon } from 'semantic-ui-react';

import MarkdownHintHelperPopup from './MarkdownHintHelperPopup';
import TooltipCommon from 'components/common/TooltipCommon';

import './MarkdownHint.css';

class MarkdownHint extends Component {
  state = {
    popupOpen: false,
  };

  onPopupClose = () => {
    this.setState({ popupOpen: false });
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="markdown-hint__component">
            <div className="item header"># {t("header")}</div>
            {/*<div className="item bold">**bold**</div>*/}
            <div className="item italics">*{t("italics")}*</div>
            <div className="item list">* {t("list")}</div>

            <TooltipCommon
              key={`markdown-hint-description-tooltip-key`}
              overlayClassName="markdown-hint-description-tooltip__component"
              header={t("Formatting Tips")}
              placement="top"
              trigger="click"
              visible={this.state.popupOpen}
              closeIcon
              onClose={this.onPopupClose}
              overlay={<MarkdownHintHelperPopup />}
            >
              <Icon
                className="question-icon"
                name="question circle outline"
                size="large"
                onClick={() => this.setState({ popupOpen: true })}
                role="button"
                tabIndex={-1}
              />
            </TooltipCommon>
          </div>
        )}
      </Translation>
    );
  }
}
export default MarkdownHint;
